export enum benefitStatus {
  active = 'active',
  inactive = 'inactive',
  underReview = 'under_review',
  expired = 'expired',
  pending = 'pending'
}
